import { render } from "./ShopTerm.vue?vue&type=template&id=ac31b8ee"
import script from "./ShopTerm.vue?vue&type=script&lang=js"
export * from "./ShopTerm.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__